/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Ocop_AddInputs */

const vi_shop_home_ocop_add = /** @type {(inputs: Shop_Home_Ocop_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm giấy chứng nhận`)
};

/**

* @param {Shop_Home_Ocop_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_add = /** @type {((inputs?: Shop_Home_Ocop_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_add(inputs)
});